import React from "react";
import { MdClose } from "react-icons/md";
import { BackContainer, ModalContainer, ContainerHeader, ContainerClose } from "./stylesModal";

const Modal = ( { children, visibility, close, title = "", largura = '', altura = '100vh', styles = ( {} ) } ) => {
    return (
        <BackContainer visibilidade={ visibility }>
            <ModalContainer style={ { width: largura, height: altura, ...styles } }>
                <ContainerClose onClick={ () => { close( false ); } }>
                    <MdClose />
                </ContainerClose>
                <ContainerHeader >
                    <div>
                        <h3 style={ { fontSize: '20px' } }>{ title }</h3>
                    </div>
                </ContainerHeader>
                <div style={ { width: '100%', height: '100%', overflow: 'auto', display: 'flex', flexDirection: 'column' } }>
                    { children }
                </div>
            </ModalContainer>
        </BackContainer>
    );
};

export default Modal;
